import { createRouter, createWebHashHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/pages/login/index.vue'),
    meta: { requiresAuth: false }
  },

  {
    path: '/',
    component: () => import('@/layouts/default.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import('@/pages/dashboard/index.vue')
      },
      {
        path: 'users',
        name: 'Users',
        component: () => import('@/pages/users/index.vue')
      },
      {
        path: 'employers',
        name: 'Employers',
        component: () => import('@/pages/employers/index.vue')
      },
      {
        path: 'work-types',
        name: 'WorkTypes',
        component: () => import('@/pages/work-types/index.vue')
      },
      {
        path: 'work-records',
        name: 'WorkRecords',
        component: () => import('@/pages/work-records/index.vue')
      },
      {
        path: 'financial-entries',
        name: 'FinancialEntries',
        component: () => import('@/pages/financial-entries/index.vue'),
        meta: { title: '财务条目管理' }
      },
      {
        path: 'financial-entries/create',
        name: 'CreateFinancialEntry',
        component: () => import('@/pages/financial-entries/edit.vue'),
        meta: { title: '新增财务条目' }
      },
      {
        path: 'financial-entries/:id/edit',
        name: 'EditFinancialEntry',
        component: () => import('@/pages/financial-entries/edit.vue'),
        meta: { title: '编辑财务条目' }
      },
      {
        path: 'financial-entry-categories',
        name: 'FinancialEntryCategories',
        component: () => import('@/pages/financial-entry-categories/index.vue'),
        meta: { title: '财务条目类别' }
      },
      {
        path: 'settings',
        name: 'Settings',
        component: () => import('@/pages/settings/index.vue')
      },
      {
        path: 'admin/rbac',
        name: 'RbacAdmin',
        component: () => import('@/pages/admin/RbacPage.vue'),
        meta: { title: '权限与角色管理' } // Optional: for breadcrumbs or page titles
      },
      {
        path: 'admins',
        name: 'Admins',
        component: () => import('@/pages/admins/index.vue')
      },
      {
        path: 'advert/list',
        name: 'Advert',
        component: () => import('@/pages/advert/index.vue'),
        meta: { title: '广告管理' }
      },
      {
        path: 'advert/positions',
        name: 'AdPositions',
        component: () => import('@/pages/advert/positions.vue'),
        meta: { title: '广告位置管理' }
      },
      {
        path: 'advert/types',
        name: 'AdTypes',
        component: () => import('@/pages/advert/types.vue'),
        meta: { title: '广告类型管理' }
      },
      {
        path: 'advert/settings',
        name: 'AdSettings',
        component: () => import('@/pages/advert/settings.vue'),
        meta: { title: '广告全局设置' }
      },
      {
        path: 'advert/statistics',
        name: 'AdStatistics',
        component: () => import('@/pages/advert/statistics.vue'),
        meta: { title: '广告统计数据' }
      },
      {
        path: 'notices',
        name: 'Notices',
        component: () => import('@/pages/notices/index.vue'),
        meta: { title: '公告管理' }
      },
      {
        path: 'notices/create',
        name: 'CreateNotice',
        component: () => import('@/pages/notices/create.vue'),
        meta: { title: '创建公告' }
      },
      {
        path: 'notices/:id/edit',
        name: 'EditNotice',
        component: () => import('@/pages/notices/edit.vue'),
        meta: { title: '编辑公告' }
      },
      {
        path: 'notices/:id/targets',
        name: 'NoticeTargets',
        component: () => import('@/pages/notices/targets.vue'),
        meta: { title: '公告目标用户' }
      },
      {
        path: 'notices/statistics',
        name: 'NoticeStatistics',
        component: () => import('@/pages/notices/statistics.vue'),
        meta: { title: '公告统计数据' }
      },
      {
        path: 'notices/:id/statistics',
        name: 'NoticeDetailStatistics',
        component: () => import('@/pages/notices/detail-statistics.vue'),
        meta: { title: '公告详细统计' }
      },
      {
        path: 'privacy',
        name: 'Privacy',
        component: () => import('@/pages/privacy/index.vue'),
        meta: { title: '隐私协议管理' }
      },

      // 分享功能路由
      {
        path: 'shares',
        name: 'Shares',
        component: () => import('@/pages/shares/index.vue'),
        meta: { title: '分享管理' }
      },
      {
        path: 'shares/:id',
        name: 'ShareDetail',
        component: () => import('@/pages/shares/[id].vue'),
        meta: { title: '分享详情' }
      },
      {
        path: 'shares/:id/visits',
        name: 'ShareVisits',
        component: () => import('@/pages/shares/[id]/visits.vue'),
        meta: { title: '访问记录' }
      },
      {
        path: 'shares/stats',
        name: 'ShareStats',
        component: () => import('@/pages/shares/stats.vue'),
        meta: { title: '分享统计' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.meta.requiresAuth && !token) {
    next('/login')
  } else {
    next()
  }
})

export default router